<template>
  <div class="gameplay-timer">
    <div class="completed" v-bind:style="completedStyle"></div>
  </div>
</template>

<script>
import { clamp } from "@/assets/js/math";
export default {
  props: {
    percentComplete: Number
  },
  computed: {
    completedStyle() {
      return {
        width: clamp(this.percentComplete * 100, 0, 100) + "%"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.gameplay-timer {
  width: 100%;
  height: rems(10px);
  background: linear-gradient(0.25turn, #fdc2d8, #fca65e, #ff7983, #041282);
  position: relative;
}
.completed {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  background-color: #fff;
}
</style>
